$(document).on('click', '.slide_itm .section_title', function(){
  var id = $(this).attr('data-id');
  $('#'+id).show();
  $("html, body").animate({ scrollTop: 0 });
  $('.store_slide').hide();
  function gridCarousel(){
    var productslider=[];
    document.querySelectorAll('.arch_slider').forEach(function(Element,index){
      let productid = Element.dataset.id;
      let outer_carousel = Element.closest('.arch_inner');
      let swiperObject={
        slidesPerView: 2,
        loop: true,
        spaceBetween : 8,
        breakpoints: {
          768: {
            slidesPerView: 'auto',
          }
        }
      };    
      productslider[productid]=new Swiper(Element,swiperObject);
    });
  }
  gridCarousel();
});
var height_image = $('.store_thumb').height();
console.log(height_image);
$('.arch_inner img').height(height_image)
$(document).on('click', '.full_width_itm .section_title', function(){
  $('.store_slide').show();
  $(this).parents('.full_width_itm').hide();
});
$('.store_thumb img').click(function(){
  $(this).parents('.slide_itm').find('.section_title').click();
  
});
$('.back_btn a').click(function(){
  $('.full_width_itm .section_title').click();
});

$(document).on('click', '.nav_itm.mega-list .megaImage_url', function(e) {
  var href = $(this).attr('href');
  if (href && href.includes('https://arte-antwerp.com/pages/stores#')) {
    setTimeout(function() {
      location.reload(); // Refresh the page
    }, 100);
  }
});
// setTimeout(function() {
// var t_height = $(window).height() - ($('.header-row').height() + $('.store_description').height() + 80);
//   if ($(window).width() >= 768){
//     $('.store_thumb figure, .img_slider figure').height(t_height);
//   }
//   var height_flex = $()
// }, 500);